import React, { useState, useEffect } from 'react'
import "./CustomDatatableNotifications.css";
import { FaPencilAlt } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";
import { useNavigate } from 'react-router-dom';
import { BiEdit } from "react-icons/bi"
import Pagination from '../Pagination/Pagination';
import { toast } from 'react-toastify';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { customFormatDate, customFormatHour, reload } from '../../utils/utils';
import AddOrEditProductCategory from '../AddOrEditProductCategory/AddOrEditProductCategory';


const CustomDatatableNotifications = (props) => {

    let monthArray = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"]

    const { columns, 
            data,
            changePage, 
            pageCount, 
            pageNumber, 
            perPage,
      } = props;
    const dispatch = useDispatch();
    const states = useSelector((state) => state, shallowEqual);


    // const [pageNumber, setPageNumber] = useState(0);
    // const itemsPerPage = 20;
    // const pagesVisited = pageNumber * itemsPerPage;

    const navigate = useNavigate();

    // const changePage = ({ selected }) => {
    //     setPageNumber(selected)
    // }

    // const pageCount = Math.ceil(data?.length / itemsPerPage)

  return (
    <div className="table-responsive ">
    <table className="table table-striped dataTable w-100">
        <thead className="">
            <tr role={"row"}>
                {columns && columns?.map((item, index) =>
                    <th key={index+"wcdnc"} className={item.label == "#" ? "text-left pl-4" :"text-left pl-3"} aria-sort="ascending" >
                        {item.label}</th>
                )}
                {/* <th className="text-center">Action</th> */}
            </tr>
            {/* {JSON.stringify(data)} */}
        </thead>
        <tbody>
            {data.length != 0 ? data?.map((item, index) =>
                <tr key={`notif-${index}`}>
                    <td className="text-left pl-4">{pageNumber > 1 ? (perPage*(pageNumber-1) + (index + 1)) : (index+1)}</td>
                    
                    <td className="text-left pl-3">
                                    {customFormatDate(item.created_at)}{" à "}{ customFormatHour(item.created_at)}
                                </td>
                                <td className="text-left pl-3">
                                    {item.transmission_id == null ? `La transmission des taux doit être effectuée.` : 
                                    `Nouveau commentaire sur la transmission de ${monthArray[parseInt(item.transmission?.mois)]} ${item.transmission?.annee}`
                                    }
                                </td>
                                <td className="text-left">
                                    {item.Type_alerte === "commentaire" ? "Commentaire" : "Alerte"}
                                </td>
                                <td className="text-left pl-3">
                                    {item.statut === 0 ? "Non Lue" : "Lue"}
                                </td>
                                <td className="text-left pl-3">
                                    {item.Type_alerte == "commentaire" ? <button className='btn btn-info' onClick={(() => navigate(`/transmission-chat/${item.transmission?.id}`))} style={{fontSize: "0.7em", fontWeight: 'bolder'}}>Voir détails</button> : <button style={{fontSize: "0.7em", fontWeight: 'bolder'}} className='btn btn-info' onClick={(() => navigate(`/transmission/new`))} >Nouvelle Transmission</button>}
                                </td>
                              
                   
                    {/* <td className="d-flex flex-nowrap text-center pl-5 justify-content-around">
                        {item.id !== states.userInfo.id && item.isBlocked == 0 && <FaUserTimes onClick={() => handleShowBlockUnblockModal(item.id, "block")} title="Bloquer" style={{ height: 25, width: 25, padding: 2, cursor: "pointer" }} className="ml-1"/>}
                    </td> */}

                </tr>
            ) : <h1 className="ok"></h1>}
        </tbody>
    </table>
    <Pagination pageCount={pageCount} changePage={changePage} />
</div>
  )
}

export default CustomDatatableNotifications